if (!customElements.get('share-links')) {
  customElements.define(
    'share-links',
    class ShareLinks extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.shareLinks = this.querySelectorAll('button');
        this.baseLink = this.dataset.baseLink;
        this.shopName = this.dataset.shopName;
        this.shareLinks.length > 0 &&
          this.shareLinks.forEach((el) => {
            el.addEventListener('click', this.onLinkClick.bind(this));
          });
      }

      onLinkClick(e) {
        e.preventDefault();
        const linkType = e.currentTarget.dataset.type;
        if (!linkType) return;
        switch (linkType) {
          case 'copy':
            this.copyLink();
            break;
          case 'twitter':
            this.shareOnTwitter(e);
            break;
          case 'facebook':
            this.shareOnFacebook(e);
            break;
          default:
            return;
        }
      }

      copyLink() {
        if (!this.baseLink) return;
        navigator.clipboard.writeText(this.baseLink).then(() => {
          window.alert('Link successfully copied to clipboard.');
        });
      }

      shareOnTwitter(e) {
        if (!this.baseLink) return;
        const text = this.shopName
          ? encodeURIComponent(`Check out this article on ${this.shopName}:`)
          : encodeURIComponent('Check out this awesome article:');
        const url = encodeURIComponent(this.baseLink);
        const twitterUrl = `https://twitter.com/intent/tweet?text=${text}&url=${url}`;

        window.open(twitterUrl, '_blank', 'width=600,height=600');
      }

      shareOnFacebook(e) {
        if (!this.baseLink) return;
        const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${this.baseLink}`;

        window.open(facebookUrl, '_blank', 'width=600,height=600');
      }
    }
  );
}
